import { render, staticRenderFns } from "./Valuacion.vue?vue&type=template&id=084ff140&scoped=true"
import script from "./Valuacion.vue?vue&type=script&lang=js"
export * from "./Valuacion.vue?vue&type=script&lang=js"
import style0 from "./Valuacion.vue?vue&type=style&index=0&id=084ff140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ff140",
  null
  
)

export default component.exports